import { GInlineCenter } from '~/presentation/ui';
import { Spinner } from '@shopify/polaris';

export const LoadingData = () => {
  return (
    <GInlineCenter minHeight="200px" align="center" inlineAlign="center">
      <Spinner accessibilityLabel="Fetching orders" size="small" />
    </GInlineCenter>
  );
};
